/** phoneme segments used by en_US_to_ipa */
export const en_US_segments = [
  'eɪ', 'aɪ', 'aʊ', 'ɔɪ', 'oʊ',
  'ɑ', 'æ', 'ɛ', 'i', 'ɪ', 'ɔ', 'u', 'ʊ', 'ə', 'ɝ',
  'dʒ', 'tʃ',
  'b', 'd', 'f', 'ɡ', 'h', 'j', 'k', 'ɫ', 'm', 'n', 'ŋ', 'p', 'ɹ', 's', 'ʃ', 't', 'ð', 'θ', 'v', 'w', 'z', 'ʒ',
];
/** single character phonemes used by en_US */
export const en_US_ipa = [
  'ɑ', 'æ', 'ɛ', 'i', 'ɪ', 'ɔ', 'u', 'ʊ', 'ə', 'ɝ',
  'a' /* aɪ, aʊ */, 'e' /* eɪ */, 'o' /* oʊ */,
  'b', 'd', 'f', 'ɡ', 'h', 'j', 'k', 'ɫ', 'm', 'n', 'ŋ', 'p', 'ɹ', 's', 'ʃ', 't', 'ð', 'θ', 'v', 'w', 'z', 'ʒ',
  'ʔ',  // used for words like uh-oh
];

// data from: https://github.com/open-dict-data/ipa-dict/releases
export let en_US_to_ipa: Record<string, string> = {};

/** set the US dictionary */
export function setUSDictionary(data: Record<string, string>) {
  en_US_to_ipa = data;
}
